<template>
  <div class="signUp-Form" @click.stop="pageBlankClick" v-if="formShow">
    <!--<div class="title">报名页面</div>-->
    <div class="form-wrap" >
      <!--酒款名称 酒款名字 wine_name-->
      <div class="tips" style="margin-bottom: 5px;">报名截止时间：{{ signUpEndTime.endTimeString }}</div>
      <ul class="form_body">
        <li>
          <div>
            <p><span class="icon">*</span>姓名</p>
            <input id="name" type="text" name="name" placeholder="姓名" v-model="formData.name" :class="{ highLight: !formData.name }"/>
          </div>
        </li>

        <li>
          <div>
            <p><span class="icon">*</span>公司</p>
            <div class="contact-content-wrap">
              <input type="text" id="company"  name="company" v-model="formData.company" :class="{ highLight: !formData.company }" placeholder="公司名称"/>
              <div id="company_type-wrap"  @click.stop="companyTypeListShow = !companyTypeListShow">
                <div class="input-wrap">
                  <input id="company_type" type="text" name="company_type" readonly="readonly" style="cursor: pointer;" v-model="formData.company_type" :class="{ highLight: !formData.company_type }" placeholder="请选择公司类型"/>
                  <div class="arrow-down"></div>
                </div>
                <div class="option-list" v-show="companyTypeListShow">
                  <div class="option"
                       :class="{ active: formData.company_type === item }"
                       v-for="(item ,index) in companyTypeList"
                       :key="index"
                       @click.stop="selectCompanyType(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div>
            <p><span class="icon">*</span>职位</p>
            <input id="position" type="text" name="position" placeholder="职位" v-model="formData.position" :class="{ highLight: !formData.position }"/>
          </div>
        </li>

        <li>
          <div>
            <p><span class="icon">*</span>联系方式</p>
            <input id="phone" type="tel" name="phone" placeholder="手机号" v-model="formData.phone" :class="{ highLight: !phoneNumValid }"/>
          </div>
        </li>
        <li class="submit-btn-wrap">
          <div>
            <button type="submit" class="clearBtn" :disabled="submitBtnDisable" :class="{ gray: !allFormDataIsValid  }" @click="checkFromData">提交</button>
          </div>
        </li>
      </ul>
    </div>

    <ocrBusinessCardCom @inputBusinessCardData="inputBusinessCardData"></ocrBusinessCardCom>
  </div>
</template>

<script>
import utils from '../utils'
import userBehaviorLogs from '../api/userBehaviorLogs'
import getBrowserType from '../utils/getBrowserType'
import getPlatform from '../utils/getPlatform'
import { postFormData } from '../api/postFormData'
import signUpEndTime from '../utils/signUpEndTime'
import ocrBusinessCardCom from './ocrBusinessCardCom'
export default {
  name: 'signUp-Form',
  props: ['pageSource'],
  components: { ocrBusinessCardCom },
  data () {
    return {
      signUpEndTime: signUpEndTime,
      formShow: true,
      browserType: getBrowserType(),
      platform: getPlatform(),
      companyTypeList: ['进口商', '代理商', '酒庄', '其它'],
      companyTypeListShow: false,
      submitBtnDisable: false,
      formData: {
        activity_name: '2019第十二届烟台国际葡萄酒博览会报名', // 活动名称
        source: this.$route.params.source || utils.getQueryString('source') || '酒咔嚓', // 来源
        name: '', // 姓名
        company: '', // 公司
        company_type: '', // 公司类型
        position: '', // 职位
        phone: '', // 电话
        weixin: '', // 微信
        remark: '' // 备注
      },
      businessCardBase64: ''
    }
  },
  computed: {
    source () {
      return this.$route.params.source || utils.getQueryString('source') || '酒咔嚓'
    },
    phoneNumValid () {
      let phoneRe = /^1[34578]\d{9}$/
      let formData = this.formData
      return formData.phone && phoneRe.test(formData.phone)
    },
    // 填写完整
    formInputComplete () {
      let formData = this.formData
      return formData.name && formData.phone && formData.company && formData.company_type && formData.position
    },
    // 填写完整，且有效
    allFormDataIsValid () {
      return this.formInputComplete && this.phoneNumValid
    }
  },
  methods: {
    inputBusinessCardData (formData, base64) {
      Object.assign(this.formData, formData)
      this.businessCardBase64 = base64
    },
    pageBlankClick () {
      this.companyTypeListShow = false
    },
    initFormData () {
      this.formData.company_type = this.companyTypeList[0]
    },
    selectCompanyType (type) {
      this.formData.company_type = type
      this.companyTypeListShow = false
    },
    checkFromData () {
      let formData = this.formData
      if (!this.formInputComplete) {
        this.$toast({
          duration: 1500,
          message: '请填写完整信息'
        })
        return
      }
      if (!this.phoneNumValid) {
        this.$toast({
          duration: 1500,
          message: '请填写正确的手机号码'
        })
        return
      }

      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '提交中...'
      })
      // 提交数据
      this.submitBtnDisable = 'disabled'
      userBehaviorLogs({
        op_event: '点击提交',
        source: this.source
      })

      postFormData(formData, this.businessCardBase64)
        .then(res => {
          this.$toast.clear()

          this.$dialog.alert({
            title: '提交成功',
            message: '谢谢你的参加，随后将有客服人员与您联系参观烟台酒博会事宜，敬请留意。',
            confirmButtonText: '确定'
          })
          // 隐藏表单
          // this.formShow = false
        })
        .catch(err => {
          this.$toast({
            mask: true,
            duration: 1000,
            message: '服务器出小差了，请重新尝试提交'
          })
          this.submitBtnDisable = false
        })
    }
  },
  mounted () {
    // 初始表单信息
    // this.initFormData()
    console.log('this.$route.params', this.$route.params)
    userBehaviorLogs({
      op_event: '进入报名表单页',
      source: this.source,
      query_column: document.referrer
    })
  }
}
</script>

<style scoped lang="less">
  @import "../less/variable";
  .tips {
    .fs(12);
    color: @mainRed;
  }
  .form-wrap{
    position: relative;
    width:100%;
    height:100%;
    min-height: 100%;
    .fs(14);
    .padding(10, 20);
    .form_body{
      .contact-desc {
        .fs(12);
      }
      p{
        color: #333333;
        position: relative;
        .pl(14);
        .mb(8);
        .icon {
          position: absolute;
          left: 0;
          color: @mainRed;
          .top(1);
          font-weight: bold;
          .fs(20);
        }
      }
      li{
        &:not(:first-child) {
          .pt(10);
        }
        div{
          >p{
            >em{
              .fs(22);
              .ml(2);
              vertical-align: middle;
              color:#C13B4D;
            }
          }
          textarea{
            width: 100%;
            .h(60);
            border: 1px solid #DCDCDC;
            border-radius: 5px;
            .mt(5);
            .padding(8, 8);
            .fs(12);
            resize: none;
          }
        }
      }
      input{
        background:none;
        outline:none;
        width:100%;
        box-sizing: border-box;
        .h(34);
        .pl(8);
        .fs(13);
        border: 1px solid #DCDCDC;
        border-radius: 2px;

        &.highLight {
          border: 2px solid #C13B4D;
        }

        &.l2 {
          .mt(8);
        }
      }
      .submit-btn-wrap{
        button{
          width:100%;
          .h(40);
          .mt(15);
          .mb(10);
          .fs(17);
          color:#fff;
          border-radius: 5px;
          background-color:#C13B4D;
          cursor: pointer;
          &[disabled],
          &.gray {
            background-color: #aaa;
          }
        }
      }
    }
    .contact-content-wrap {
      display: flex;
      position: relative;
      .username {
        flex: 1;
      }
    }
    #company_type-wrap {
      position: relative;
      .w(270);
      .arrow-down {
        position: absolute;
        cursor: pointer;
        .right(15);
        //.top(18);
        .top(10);
        .w(12);
        .h(16);
        background: url("../images/arrow-down.png") no-repeat center center / contain;
      }
      .input-wrap {
        position: relative;
        input {
          box-sizing: border-box;
        }
      }
      .option-list {
        position: absolute;
        .top(36);
        width: 100%;
        background-color: #fff;
        box-shadow: 0 1px 12px 2px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        z-index: 1;
        color: #bfbfbf;
        @num: 14;
        .option {
          cursor: pointer;
          .mb(@num);
          .padding(0, @num);
          &:first-child {
            .mt(@num);
          }
          &:hover,
          &:active {
            color: #333;
          }

          &.active {
            color: #333;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/signUpForm.vue